module.exports = __webpack_public_path__ + "f7c8d2e2caf71e71f5e90d1eaf2bd930.png";